import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, Plus, Check } from 'lucide-react';

function AppSelector() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [apps, setApps] = useState([]);
  const [currentApp, setCurrentApp] = useState(null);

  useEffect(() => {
    loadApps();
  }, []);

  const loadApps = () => {
    // 从 localStorage 加载所有应用
    const storedApps = localStorage.getItem('qianshu_apps');
    if (storedApps) {
      const appList = JSON.parse(storedApps);
      setApps(appList);
      
      // 加载当前选中的应用
      const currentConfig = localStorage.getItem('qianshu_config');
      if (currentConfig) {
        const config = JSON.parse(currentConfig);
        const current = appList.find(app => app.appId === config.appId);
        setCurrentApp(current);
      }
    }
  };

  const switchApp = (app) => {
    // 切换到选中的应用
    const config = {
      apiEndpoint: app.apiEndpoint,
      appId: app.appId,
      apiKey: app.apiKey,
    };
    localStorage.setItem('qianshu_config', JSON.stringify(config));
    setCurrentApp(app);
    setIsOpen(false);
    
    // 刷新页面以应用新配置
    window.location.reload();
  };

  const addNewApp = () => {
    setIsOpen(false);
    navigate('/settings?mode=new');
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <span className="text-sm font-medium text-gray-700">
          {currentApp ? currentApp.name : '选择应用'}
        </span>
        <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
            <div className="p-2">
              <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                我的应用
              </div>
              {apps.length > 0 ? (
                apps.map((app) => (
                  <button
                    key={app.appId}
                    onClick={() => switchApp(app)}
                    className={`w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 flex items-center justify-between ${
                      currentApp?.appId === app.appId ? 'bg-primary-50' : ''
                    }`}
                    title={app.appId}
                  >
                    <div className="flex-1 min-w-0 mr-2">
                      <div className="text-sm font-medium text-gray-900">{app.name}</div>
                      <div className="text-xs text-gray-500 truncate" title={app.appId}>
                        {app.appId}
                      </div>
                    </div>
                    {currentApp?.appId === app.appId && (
                      <Check className="w-4 h-4 text-primary-600 flex-shrink-0" />
                    )}
                  </button>
                ))
              ) : (
                <div className="px-3 py-2 text-sm text-gray-500">
                  暂无应用
                </div>
              )}
              
              <div className="border-t border-gray-200 mt-2 pt-2">
                <button
                  onClick={addNewApp}
                  className="w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 flex items-center text-primary-600"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  <span className="text-sm font-medium">添加应用</span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AppSelector;
